<div class="smart-input-container">
  <div
    class="input-wrapper"
    [class.has-country-selector]="inputMode === 'phone'"
  >
    <!-- Country Selector (only visible in phone mode) -->
    <div
      *ngIf="inputMode === 'phone'"
      class="country-selector"
      (click)="toggleDropdown()"
      [class.disabled]="isDisabled"
      role="button"
      tabindex="0"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isDropdownOpen"
    >
      <!-- <span class="flag">{{ selectedCountry.flag }}</span> -->
      <picture class="flag">
        <source
          type="image/webp"
          [srcset]="
            'https://flagcdn.com/16x12/' +
            selectedCountry.code.toLowerCase() +
            '.webp,
             https://flagcdn.com/32x24/' +
            selectedCountry.code.toLowerCase() +
            '.webp 2x,
             https://flagcdn.com/48x36/' +
            selectedCountry.code.toLowerCase() +
            '.webp 3x'
          "
        />
        <source
          type="image/png"
          [srcset]="
            'https://flagcdn.com/16x12/' +
            selectedCountry.code.toLowerCase() +
            '.png,
             https://flagcdn.com/32x24/' +
            selectedCountry.code.toLowerCase() +
            '.png 2x,
             https://flagcdn.com/48x36/' +
            selectedCountry.code.toLowerCase() +
            '.png 3x'
          "
        />
        <img
          [src]="
            'https://flagcdn.com/16x12/' +
            selectedCountry.code.toLowerCase() +
            '.png'
          "
          width="16"
          height="12"
          [alt]="selectedCountry.name"
          loading="lazy"
        />
      </picture>
      <span class="dial-code">{{ selectedCountry.dialCode }}</span>
      <svg
        class="dropdown-arrow"
        [class.open]="isDropdownOpen"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M2 4L6 8L10 4"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>

      <!-- Dropdown Menu -->
      <div
        *ngIf="isDropdownOpen"
        class="country-dropdown"
        (click)="$event.stopPropagation()"
      >
        <!-- Search Input -->
        <div class="dropdown-search">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            placeholder="Buscar país..."
            class="search-input"
          />
        </div>

        <!-- Countries List -->
        <div class="countries-list">
          <div
            *ngFor="let country of filteredCountries"
            class="country-item"
            [class.selected]="country.code === selectedCountry.code"
            (click)="selectCountry(country)"
          >
            <!-- <span class="flag">{{ country.flag }}</span> -->
            <picture class="flag">
              <source
                type="image/webp"
                [srcset]="
                  'https://flagcdn.com/16x12/' +
                  country.code.toLowerCase() +
                  '.webp,
                   https://flagcdn.com/32x24/' +
                  country.code.toLowerCase() +
                  '.webp 2x,
                   https://flagcdn.com/48x36/' +
                  country.code.toLowerCase() +
                  '.webp 3x'
                "
              />
              <source
                type="image/png"
                [srcset]="
                  'https://flagcdn.com/16x12/' +
                  country.code.toLowerCase() +
                  '.png,
                   https://flagcdn.com/32x24/' +
                  country.code.toLowerCase() +
                  '.png 2x,
                   https://flagcdn.com/48x36/' +
                  country.code.toLowerCase() +
                  '.png 3x'
                "
              />
              <img
                [src]="
                  'https://flagcdn.com/16x12/' +
                  country.code.toLowerCase() +
                  '.png'
                "
                width="16"
                height="12"
                [alt]="country.name"
                loading="lazy"
              />
            </picture>
            <span class="country-name">{{ country.name }}</span>
            <span class="dial-code">{{ country.dialCode }}</span>
          </div>

          <div *ngIf="filteredCountries.length === 0" class="no-results">
            No se encontraron países
          </div>
        </div>
      </div>
    </div>

    <!-- Main Input -->
    <input
      [type]="inputType"
      class="form-input"
      [class.is-invalid]="isInvalid"
      [class.with-country]="inputMode === 'phone'"
      [placeholder]="placeholder"
      [value]="inputValue"
      [disabled]="isDisabled"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
      [autocomplete]="inputMode === 'email' ? 'email' : 'tel'"
    />
  </div>

  <!-- Error Message -->
  <div class="invalid-feedback" *ngIf="isInvalid">
    {{ errorMessage }}
  </div>

  <!-- Mode Indicator (optional, for debugging) -->
  <!-- <div class="mode-indicator" *ngIf="inputMode !== 'undetermined'">
      Modo: {{ inputMode === 'email' ? 'Email' : 'Teléfono' }}
    </div> -->
</div>
